import { requireAnySystemPermission } from '../../../../../../backend/features/permissions/shared';
export function getStatusAndRoleInNewOrganization(userState, newOrgId) {
    const accountOrgData = {
        orgStatus: {},
    };
    userState.orgStatus.forEach((status) => {
        const [orgId, userOrgStatus] = status.split('_');
        accountOrgData.orgStatus[orgId] = userOrgStatus;
    });
    if (requireAnySystemPermission(userState, 'manage-accounts')) {
        accountOrgData.orgRole = { [newOrgId]: 'user' };
        accountOrgData.orgStatus[newOrgId] = 'accepted';
        for (const [orgId, userOrgRole] of Object.entries(userState.orgRole)) {
            accountOrgData.orgRole[orgId] = userOrgRole;
        }
    }
    else {
        accountOrgData.orgStatus[newOrgId] = 'pending';
    }
    return accountOrgData;
}
